import { render } from "./QuienesSomosPage.vue?vue&type=template&id=537e42d5&scoped=true"
import script from "./QuienesSomosPage.vue?vue&type=script&lang=js"
export * from "./QuienesSomosPage.vue?vue&type=script&lang=js"

import "./QuienesSomosPage.vue?vue&type=style&index=0&id=537e42d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537e42d5"]])

export default __exports__